import { Cursor } from "./Cursor";
export class ViewCursor {
    constructor(view, x, y, onEntityX, onEntityY) {
        this.view = view;
        this.pt = new Cursor({ x, y });
        this.onEntityX = onEntityX;
        this.onEntityY = onEntityY;
    }
    movementUpToEdge(dir) {
        switch (dir) {
            case 2 /* left */: return this.pt.x;
            case 0 /* right */: return 1 - this.pt.x;
            case 3 /* top */: return this.pt.y;
            case 1 /* bottom */: return 1 - this.pt.y;
        }
    }
    moveWithinTile(dir, dist) {
        this.pt.step(dir, dist);
    }
    tryCrossEdge(dir) {
        if (this.movementUpToEdge(dir) === 0) {
            const next = this.view.getNeighbor(dir);
            if (!next)
                return false;
            this.pt.step(dir, -1);
            this.view = next;
            return true;
        }
        return true;
    }
    copy(other) {
        this.pt = other.pt.fork();
        this.view = other.view;
        this.onEntityY = other.onEntityY;
        this.onEntityX = other.onEntityX;
    }
    clone() {
        return new ViewCursor(this.view, this.pt.x, this.pt.y, this.onEntityX, this.onEntityY);
    }
    move(dx, dy) {
        let xSide = dx < 0 ? 2 /* left */ : 0 /* right */;
        let ySide = dy < 0 ? 3 /* top */ : 1 /* bottom */;
        let xLeft = Math.abs(dx);
        let yLeft = Math.abs(dy);
        let xLocked = xLeft === 0;
        let yLocked = yLeft === 0;
        let i = 0;
        while ((xLeft > 0 || yLeft > 0) && i < 100) {
            i++;
            if (!xLocked && xLeft > 0) {
                let oPosn = xLeft;
                xLeft = this.tryMove(xSide, xLeft);
                yLocked = yLocked && (oPosn === xLeft || yLeft <= 0);
                xLocked = true;
            }
            if (yLocked)
                break;
            if (!yLocked && yLeft > 0) {
                let oPosn = yLeft;
                yLeft = this.tryMove(ySide, yLeft);
                xLocked = xLocked && (oPosn === yLeft || xLeft <= 0);
                yLocked = true;
            }
            if (xLocked)
                break;
        }
        if (xLeft !== 0 && yLeft !== 0)
            console.log(xLeft, yLeft);
        return xLeft === 0 && yLeft === 0;
    }
    tryMove(dir, dist) {
        let i = 0;
        let left = dist;
        while (left > 0 && i < 100) {
            i--;
            const canMove = Math.min(this.movementUpToEdge(dir), left);
            if (canMove > 0) {
                this.moveWithinTile(dir, canMove);
            }
            left -= canMove;
            if (left === canMove)
                break;
            if (!this.tryCrossEdge(dir))
                break;
        }
        return left;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/ViewCursor.ts
// module id = 22
// module chunks = 0